import styled from 'styled-components';
import { ReactComponent as SuccessSvg } from './icons/success.svg';
import { ReactComponent as ErrorSvg } from './icons/error.svg';
import { H4 } from 'components/typography';
import { color, typography } from 'styles/settings';
import { normalize } from 'utils/styles';

export const SuccessIcon = styled(SuccessSvg)`
  height: ${normalize('20px')};
  width: ${normalize('20px')};
  margin-right: ${normalize('6px')};
`;
export const ErrorIcon = styled(ErrorSvg)`
  height: ${normalize('20px')};
  width: ${normalize('20px')};
  margin-right: ${normalize('6px')};
`;

export const Container = styled.div`
  align-items: center;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  padding: ${normalize('15px')};
`;

export const Text = styled(H4)`
  ${typography.font.medium};
  color: ${color.neutral.white};
`;
